<template>
    <div class="row mb-8">
        <div class="col d-flex justify-content-start">
            <span class="title">{{ $t('Delivery.DeliveryPerson.Add') }}</span>
        </div>
        <div class="col d-flex gap-2 justify-content-end">
            <genericBtnComponent
                :disabled="loader"
                :ClickFun="createDeliveryPerson"
                svg="1"
                :Title="$t('Delivery.save')"
                :loader="loader"
            />
        </div>
    </div>

    <v-card elevation="0">
        <div class="row ma-4">
            <div class="col-4">
                <v-card-title>{{ $t('Delivery.DeliveryPerson.Name') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="fullName"
                    maxlength="50"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.DeliveryPerson.Name') })"
                    variant="outlined"
                ></v-text-field>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.email') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="emailAddress"
                    maxlength="100"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.email') })"
                    variant="outlined"
                ></v-text-field>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.Phone') }}</v-card-title>
                <v-text-field
                    v-model="phone"
                    maxlength="15"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.Phone') })"
                    variant="outlined"
                ></v-text-field>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.TaxNumber') }}</v-card-title>
                <v-text-field
                    v-model="taxIdentificationNumber"
                    maxlength="30"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.TaxNumber') })"
                    variant="outlined"
                ></v-text-field>
            </div>
             <div class="col-4">
                <v-card-title>{{ $t("Delivery.DeliveryPerson.IsAdmin") }}</v-card-title>
                <v-checkbox class="shrink mr-2 mt-0" v-model="isAdmin" id="remember" name="remember"
                            :label="$t('Delivery.DeliveryPerson.IsAdmin')" color="#114EF7" hide-details>
                        </v-checkbox>
   <!-- <span class="warningHint" id="WarningMsgIsAdmin">{{ msg.isAdmin }}</span>-->
            </div>
            
        </div>
         <div class="col-4 justify-content-start">
            <uploadLogo
            @addLogo="setLogo" />
        </div>
        <div class="row ma-4">
            <div class="col-4">
                <v-card-title>{{ $t('Delivery.DeliveryPerson.password') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="password"
                    type="password"
                    maxlength="50"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.password') })"
                    variant="outlined"
                ></v-text-field>
            </div>

            <div class="col-4">
                <v-card-title>{{ $t('Delivery.DeliveryPerson.Confrmpassword') }}<span class="red">*</span></v-card-title>
                <v-text-field
                    v-model="confirmPassword"
                    type="password"
                    maxlength="50"
                    :placeholder="$t('placeholder.enter', { itm: $t('Delivery.confirmPassword') })"
                    variant="outlined"
                ></v-text-field>
            </div>
        </div>
    </v-card>
</template>
<script>
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import { addDeliveryPerson  } from "@/api/index";
import uploadLogo from '@/genericComponent/uploadLogo.vue'
export default {
    components: {
        genericBtnComponent ,  uploadLogo
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.Brands');
         
    },
    props: {
        deliveryCompanyId: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        fullName: "",
        emailAddress: "",
        phone: "",
        taxIdentificationNumber: "",
        password: "",
        confirmPassword: "",
        loader: false,
        isAdmin: false,
        msg: [],
        logoImage: null,
}),
   methods : {
    setLogo(value) {
            this.logoImage = value
        },
        
    async createDeliveryPerson() {
            this.loader = true;
            try {
                // Créer un objet FormData
                const formData = new FormData();
                formData.append('deliveryCompanyId', this.deliveryCompanyId);
                formData.append('fullName', this.fullName);
                formData.append('emailAddress', this.emailAddress);
                formData.append('phone', this.phone || '');
                formData.append('taxIdentificationNumber', this.taxIdentificationNumber || '');
                formData.append('password', this.password);
                formData.append('confirmPassword', this.confirmPassword);
                formData.append('IsAdmin', this.isAdmin);
                if(this.logoImage) formData.append('Photo',this.logoImage)
                // Appeler l'API
                await addDeliveryPerson(formData);

                // Redirection et notification
                this.$router.push({ path: "/MyDeliveryCompany" });
                this.$emit("snackbarSuccess", this.$t("Delivery.personCreated"));
            } catch (error) {
                console.error("Error creating delivery person:", error);
                this.$emit("snackbarError", this.$t("Delivery.personCreationFailed"));
            } finally {
                this.loader = false;
            }
        },
    



   



   
   
    navigateToList() {
            this.$router.push({ path: "/BrandsMenu" });
        },

   },
   computed : {
    

   }
    
};
</script>
<style scoped>
.title {
    margin-top: auto;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    padding-left: 0;
    margin-top: 0;
    padding-top: 0;
}



.v-autocomplete {
    margin-left: 12px !important;
}

.border-bottom {
    border-bottom: 1px solid #ddd;
}

.border-right {
    border: 1px solid #ddd;
    text-align: center;
    border-style: dotted;
    padding: 2px 4px;
}

.totals {
    margin-top: 20px;
    /* font-weight: bold; */
}

.rounded-table {
    border-radius: 10px;
}

.totals p {
    margin: 5px 0;
}

.align-right {
    padding-right: 85px;
    text-align: right;
    position: relative;
}

.align-devise {
    float: right;
    margin-left: -16px;
}

.custom-divider {
    border-top: 1px solid;
    border-color: currentColor;
}

.add-line {
    display: inline-block;
    color: blue;
    cursor: pointer;
    margin-top: 10px;
}

.add-icon {
    color: #0000FF;
}

.customWarningHint {
    color: #F25C5C;
    padding: 12px 0px 12px 12px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 0px;
    display: block;
    text-align: left;
    text-wrap: nowrap;
}
</style>